export default __webpack_public_path__ + "static/107999-42dd6370d41320cf75446f1172fa87d1.jpg";